module.exports = __webpack_public_path__ + "img/avatar6.5198224c.png";